import { Licencia, LicenciaForm, LicenciaUpsert } from '@models/.';
import { transformDeviceForm, transformLicenseStateForm } from '..';
import { LicenciaResumenForm } from '@core/models/licencia';
import { LicenseDeviceStatusEnum } from '@core/enums';

export function transformToData(license: Licencia | null): Licencia | null {
  if (!license) return null;
  
  return {
    ...license,
    nombre: `${license.nombre} ${license?.dispositivo?.idDispositivo ? '(' + LicenseDeviceStatusEnum.InUse  + ')' : '' }`,
    dispositivoId: license?.dispositivo?.idDispositivo ?? null
  };
}

export function transformArrayToData(licenses: Licencia[]): Licencia[] {
  return (licenses ?? []).map((license) => transformToData(license)).filter((l) => !!l) ?? [];
}

export function transformToForm(license?: Licencia): LicenciaForm | undefined {
  if (!license) return;
  
  const {
    idLicencia: id,
    codigo: code,
    nombre: name,
    numero: number,
    nombrelocalCanal: nameLocalCanal,
    tipo: type,
    disponible: available,
    licenciaEstadoId: licenciaEstadoId,
    localCanalId: localCanalId,
    tiendaId: tiendaId,
    licenciaEstado: licenseState,
    dispositivo: device,
    dispositivoId: deviceId,
  } = {
    ...license,
    dispositivoId: license?.dispositivo?.idDispositivo
  };

  return {
    id,
    code,
    name,
    number,
    nameLocalCanal,
    type,
    available,
    licenciaEstadoId,
    localCanalId,
    tiendaId,
    licenseState: transformLicenseStateForm(licenseState),
    device: transformDeviceForm(device),
    deviceId,
  };
}

export function transformToUpsert(licensesForm: LicenciaResumenForm[] = []): LicenciaUpsert[] {
  return licensesForm
    .filter(({ localCanalId }) => !!localCanalId)
    .map(({ localCanalId, total }) => ({
      cantidad: total,
      localCanalId
    }));
}